export default {
  // Navigation
  'nav.timer': 'Pemasa',
  'nav.stopwatch': 'Jam Randik',
  'nav.worldclock': 'Jam Dunia',
  'nav.timestamp': 'Cap Waktu',
  'nav.home': 'Laman Utama',

  // Common buttons and actions
  'button.start': 'Mula',
  'button.pause': 'Jeda',
  'button.stop': 'Henti',
  'button.reset': 'Tetapkan Semula',
  'button.ok': 'OK',
  'button.cancel': 'Batal',
  'button.close': 'Tutup',
  'button.save': 'Simpan',
  'button.delete': 'Padam',
  'button.edit': 'Edit',
  'button.back': 'Kembali',
  'button.next': 'Seterusnya',
  'button.previous': 'Sebelumnya',
  'button.submit': 'Hantar',
  'button.confirm': 'Sahkan',
  'button.convert': 'Tukar',
  'button.copy': 'Salin',
  'button.copied': 'Telah Disalin!',
  'button.now': 'Sekarang',
  'button.clear': 'Padamkan',

  // Common labels
  'label.hours': 'Jam',
  'label.minutes': 'Minit',
  'label.seconds': 'Saat',
  'label.milliseconds': 'Milisaat',
  'label.minute': 'Minit',
  'label.second': 'Saat',
  'label.sound': 'Bunyi',
  'label.soundAlert': 'Bunyi',
  'label.fullscreen': 'Skrin Penuh',
  'label.language': 'Bahasa',
  'label.selectLanguage': 'Pilih Bahasa',
  'label.languageSelectorInfo': 'Kini menyokong {{count}} bahasa. Pilih bahasa pilihan anda dari pilihan di atas.',

  // Common messages
  'message.timerComplete': 'Pemasa Selesai!',
  'message.timerCompleteDesc': 'Pemasa anda telah selesai',
  'message.timerCompleteBody': 'Pemasa undur terbalik anda telah selesai!',
  'message.stopwatchStarted': 'Jam Randik Dimulai',
  'message.stopwatchStartedDesc': 'Pemasaan jam randik telah dimulai',
  'message.stopwatchStopped': 'Jam Randik Dihenti',
  'message.stopwatchStoppedDesc': 'Pemasaan jam randik telah dihenti',
  'message.stopwatchReset': 'Jam Randik Ditetapkan Semula',
  'message.stopwatchResetDesc': 'Jam randik telah ditetapkan semula ke sifar',
  'message.notificationPermission': 'Benarkan pemberitahuan untuk mendapat amaran apabila pemasa selesai',
  'message.clickToEdit': 'Klik nombor masa untuk mengedit masa secara langsung',
  'message.addHours': '+ Tambah Jam',
  'message.escToExit': 'Tekan ESC untuk keluar daripada skrin penuh',
  'message.timeRemaining': '{{minutes}} minit {{seconds}} saat tinggal',
  'message.minutesRemaining': '{{minutes}} minit tinggal',
  'message.secondsRemaining': '{{seconds}} saat tinggal',
  'message.stopwatchTimeElapsed': '{{minutes}} minit {{seconds}} saat berlalu',
  'message.stopwatchMinutesElapsed': '{{minutes}} minit berlalu',
  'message.stopwatchSecondsElapsed': '{{seconds}} saat berlalu',
  'message.invalidTimestamp': 'Cap waktu tidak sah',
  'message.invalidDateTime': 'Tarikh dan masa tidak sah',
  'message.conversionError': 'Ralat penukaran',

  // Time units
  'time.am': 'PG',
  'time.pm': 'PTG',
  'time.now': 'Sekarang',
  'time.today': 'Hari Ini',
  'time.yesterday': 'Semalam',
  'time.tomorrow': 'Esok Hari',

  // Common errors
  'error.pageNotFound': 'Laman Tidak Ditemui',
  'error.somethingWrong': 'Sesuatu tidak kena',
  'error.tryAgain': 'Sila cuba lagi kemudian',

  // Footer
  'footer.about': 'Perihal timer.today',
  'footer.aboutDesc': 'timer.today ialah platform alat pemasaan dalam talian profesional yang menyediakan tiga ciri teras:',
  'footer.timerDesc': 'Alat undur terbalik yang boleh disesuaikan dengan sokongan tetapan minit dan jam, sempurna untuk fokus kerja, pemasaan memasak, pengurusan pembelajaran dan banyak lagi. Menampilkan amaran bunyi dan pemberitahuan desktop.',
  'footer.stopwatchDesc': 'Alat pemasaan ketepatan tinggi dengan ketepatan milisaat, sesuai untuk latihan sukan, operasi memasak, latihan peperiksaan dan senario lain yang memerlukan pemasaan tepat.',
  'footer.worldClockDesc': 'Paparan masa nyata waktu bandar utama di seluruh dunia dengan pengiraan zon masa pintar, memudahkan komunikasi perniagaan antarabangsa dan kerjasama lintas zon masa.',
  'footer.timestampDesc': 'Penukar cap waktu Unix yang menyokong penukaran dua arah antara cap waktu dan tarikh masa, dengan sokongan format saat dan milisaat.',
  'footer.termsOfService': 'Syarat Perkhidmatan',
  'footer.privacy': 'Privasi',
  'footer.contactUs': 'Hubungi Kami',
  'footer.changeLanguage': 'tukar bahasa',
  'footer.moreLanguage': 'lebih banyak bahasa',
  'footer.copyright': '© timer.today 2024',

  // Quick actions
  'quick.add30s': '+30 saat',
  'quick.add1min': '+1 Minit',
  'quick.add5min': '+5 Minit',
  'quick.add10min': '+10 Minit',
  'quick.add30min': '+30 Minit',

  // Breadcrumb
  'breadcrumb.minuteTimer': 'Pemasa {{minutes}} Minit',
  'breadcrumb.timer': 'Pemasa',
  'breadcrumb.stopwatch': 'Jam Randik',
  'breadcrumb.worldClock': 'Jam Dunia',
  'breadcrumb.termsOfService': 'Syarat Perkhidmatan',
};